module.exports = __webpack_public_path__ + "img/touxiang_reset.23241f30.png";